import * as Immutable from 'immutable';
import {
  GET_MAINTENANCEMODE_REQUESTED,
  GET_MAINTENANCEMODE_COMPLETED,
  GET_MAINTENANCEMODE_FAILED,
} from '../../actions/maintenancemode/types';

const schema = {
  // status: 'INIT', // INIT/OK/ERROR
  error: null,
  data: null,
  gettingdata: false,
  settingdata: false,
  gotdata: false,
  setdata: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MAINTENANCEMODE_REQUESTED:
      return state
        .set('error', null)
        .set('data', null)
        .set('gettingdata', true);

    case GET_MAINTENANCEMODE_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('data', action.payload);

    case GET_MAINTENANCEMODE_FAILED:
      return state.set('error', action.payload);

    default:
      return state;
  }
};

export { initialState };

export default reducer;
